export default __webpack_public_path__ + "static/media/NotFound2.a7dabf00.gif";